
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import CatalogEmptyState from "../../../common/catalog/CatalogEmptyState";
import Loading from "../../../common/loading/Loading";
import Payment from "./Payment";

export default function PaymentSection() {
	const [payments, setPayments] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchPayments();
	}, []);

	function fetchPayments() {
		setIsLoading(true);
		setErrorMessage("");
		api
			.paymentList({
				token: LoginHelper.getToken(),
			})
			.then((results) => {
				setPayments(results ?? []);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<div className="flex flex-col gap-5">
			<section
				className="relative overflow-hidden rounded-[16px] border border-darkBlue/10 bg-gradient-to-br from-white via-lightCta/80 to-white shadow-[0_10px_28px_rgba(39,106,166,0.1)]"
				aria-label="تاریخچه پرداخت‌ها"
			>
				<div
					className="h-[3px] w-full bg-gradient-to-l from-cta via-[#FF8A6B] to-darkBlue"
					aria-hidden
				/>
				<div className="px-5 py-5 md:py-6 text-center">
					<h1 className="font-Vazir-600 text-[17px] md:text-[18px] text-darkBlue">
						تاریخچه پرداخت‌ها
					</h1>
					<p className="mt-2 font-Vazir-400 text-[13px] text-darkBlue/55">
						فهرست تراکنش‌های موفق و جزئیات هر پرداخت
					</p>
				</div>
			</section>

			{isLoading && (
				<div className="flex justify-center py-12">
					<Loading color="#ff694b" width={44} />
				</div>
			)}

			{!isLoading && errorMessage && (
				<div className="rounded-[14px] border border-red-200 bg-white px-4 py-6 text-center font-Vazir-400 text-[15px] text-[#cc0000]">
					{errorMessage}
				</div>
			)}

			{!isLoading && !errorMessage && payments.length >= 1 && (
				<ul className="m-0 flex list-none flex-col gap-3 p-0">
					{payments.map((payment) => (
						<li key={payment.id}>
							<Payment payment={payment} />
						</li>
					))}
				</ul>
			)}

			{!isLoading && !errorMessage && payments.length === 0 && (
				<CatalogEmptyState
					message="هنوز پرداختی ثبت نشده است."
					hint="پس از خرید کارگاه، وبینار یا اشتراک، رسید اینجا نمایش داده می‌شود."
				/>
			)}
		</div>
	);
}
